import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfficeListPopupComponent } from './office-list-popup.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [OfficeListPopupComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    TranslateModule,
    RouterModule
  ],
  exports: [
    OfficeListPopupComponent
  ],
  entryComponents: [
    OfficeListPopupComponent
  ]
})
export class OfficeListPopupModule { }
